/* eslint-disable no-empty-pattern */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../config/httpConfig";

const initialState = {
    docDropdown: {},
    docs: [],
    loading: false,
    error: null,
};

export const masterDocs = createAsyncThunk(
    "documents/masterDocs",
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get("/api/admin/v1/dropdown/masterDocs");
            return response.response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const document = createAsyncThunk(
    "documents/document",
    async (payload, { rejectWithValue }) => {
        try {
            const params = {};

            if (payload.type) params.type = payload.type;
            if (payload.orgId) params.orgId = payload.orgId;
            if (payload.entId) params.entId = payload.entId;
            if (payload.busEntId) params.busEntId = payload.busEntId;
            if (payload.dealId) params.dealId = payload.dealId;
            if (payload.dealCategoryId) params.dealCategoryId = payload.dealCategoryId;

            // ✅ investor type ki matrame kyc
            if (payload?.type === "INVESTOR" && payload?.kyc !== undefined) {
                params.kyc = payload.kyc;
            }

            const response = await axios.get(`/api/admin/v1/document`, { params });

            return response.response;
        } catch (error) {
            return rejectWithValue(error?.response?.data || error.message);
        }
    }
);

export const uploadFinancialMetrics = createAsyncThunk(
    "documents/uploadFinancialMetrics",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                "/api/admin/uploadFinancialMetrics",
                payload
            );

            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const getFinancialMetrics = createAsyncThunk(
    "documents/getFinancialMetrics",
    async (payload, { rejectWithValue }) => {
        try {
            const params = {};
            if (payload?.orgId) params.orgId = payload.orgId;
            if (payload?.entId) params.entId = payload.entId;

            const response = await axios.get("/api/admin/getFinancialMetrics", {
                params,
            });

            return response.response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const uploadOtherDocuments = createAsyncThunk(
    "documents/uploadOtherDocuments",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                "/api/admin/busOtherDocs",
                payload
            );

            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const downloadPage = createAsyncThunk(
    "documents/downloadPage",
    async ({ type, screenName, dealType, dealCategoryId, statusId }, { rejectWithValue }) => {
        try {
            const query = new URLSearchParams({ type });
            if (dealType) query.append("dealType", dealType);
            if (dealCategoryId) query.append("dealCategoryId", dealCategoryId);
            if (statusId) {
                const formattedStatusId = Array.isArray(statusId) ? statusId.join(",") : statusId;
                query.append("statusId", formattedStatusId);
            }


            const response = await axios.get(
                `/api/admin/v1/export/downloadPage/${screenName}?${query.toString()}`,
                { responseType: "blob" }
            );
            return response;
        } catch (error) {
            return rejectWithValue(error?.response?.data || error.message);
        }
    }
);

export const detailedViewDownload = createAsyncThunk(
    "documents/detailedViewDownload",
    async ({ type, id }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `/api/admin/v1/export/download/${type}/${id}`,
                { responseType: "blob" }
            );
            return response;
        } catch (error) {
            return rejectWithValue(error?.response?.data || error.message);
        }
    }
);


export const documentSlice = createSlice({
    name: "documents",
    initialState,

    extraReducers: (builder) => {
        builder.addCase(masterDocs.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(masterDocs.fulfilled, (state, action) => {
            state.loading = false;
            state.docDropdown = action.payload;
            state.error = null;
        });
        builder.addCase(masterDocs.rejected, (state, action) => {
            state.loading = false;
            state.docDropdown = null;
            state.error = action.payload;
        });


        builder.addCase(document.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(document.fulfilled, (state, action) => {
            state.loading = false;
            state.docs = action.payload;
            state.error = null;
        });
        builder.addCase(document.rejected, (state, action) => {
            state.loading = false;
            state.docs = [];
            state.error = action.payload;
        });


        builder.addCase(uploadFinancialMetrics.pending, (state) => {
            state.loading = true;
            state.error = null;
        });

        builder.addCase(uploadFinancialMetrics.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
        });

        builder.addCase(uploadFinancialMetrics.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });


        builder.addCase(downloadPage.pending, (state) => {
            state.loading = true;
            state.error = null;
        });

        builder.addCase(downloadPage.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
        });

        builder.addCase(downloadPage.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        builder.addCase(detailedViewDownload.pending, (state) => {
            state.loading = true;
            state.error = null;
        });

        builder.addCase(detailedViewDownload.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
        });

        builder.addCase(detailedViewDownload.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

    },

    reducers: {
        clearDocData: (state) => {
            state.docs = [];
        },
    },
});

export const { clearDocData } = documentSlice.actions;

export default documentSlice.reducer;